export const StatisticCardData = [
  {
    id: 0,
    antet: "STATISTICI",
    title: "Atribuțiile DSU",
    href: "https://lookerstudio.google.com/embed/reporting/a3e9ea3b-65f6-496f-8945-4032ba33ee1c/page/p_mnockd85dd",
  },
  {
    id: 1,
    antet: "STATISTICI",
    title: "Relația cu societatea civilă",
    href: "https://lookerstudio.google.com/embed/reporting/a3e9ea3b-65f6-496f-8945-4032ba33ee1c/page/p_hojdjy22dd",
  },
];
